import * as React from "react";
const SVGComponent = (props) => (
  <svg
    id="Layer_1"
    data-name="Layer 1"
    xmlns="http://www.w3.org/2000/svg"
    width={256}
    height={256}
    viewBox="0 0 256 256"
    {...props}
  >
    <defs>
      <style>{"\n      .cls-1 {\n        fill: #c88242;\n      }\n    "}</style>
    </defs>
    <g>
      <path
        className="cls-1"
        d="M92,85.4c-9-7.2-18.9-12.1-30.5-13.7l-1.1,4.2c3.7,15.6,11,29.1,22.5,40.1l17.1,11.2,21.1,12.7c.9-4.4-.2-7.7-1.2-11.4-6.7-17.4-13.2-31.3-28-43.1Z"
      />
      <path
        className="cls-1"
        d="M244.5,112.2c-1.4-6.6-5.2-12.8-9.3-18.3,0,0-13.8-33.5-32.2-44-18.3-10.5-71.5-16.5-71.5-16.5-12.7-2.2-46.2,4.7-56.4,7.8-20.4,4.2-33.7,19.8-44.2,36.7-16.8,27.2-23.9,58.8-18.3,89.3,3.2,17.2,11.9,31.3,26.5,42.5,6.8,5.3,18,10.1,28.1,13.7l5.8-2.3c9.5-1.1,16.4-12.5,22.8-20.2l6.1-7.4c2.3-2.8,3.5-5.4,2.9-9.1-1.5-9.6.1-19.2,3.3-28.3,1.7-4.9,1.7-10.2-2.9-13.3l-14.2-9.5c-4.9-3.3-9.6-6.1-14.1-10.1-14.3-13-24.1-30.5-27.3-49.7-.6-3.5-1.3-8.9,1.3-11.1,3.1-2.6,8.6-1.9,12.6-1,21.9,5.2,40.4,18.6,53.2,37l14.8,23.4c1.6,2.5,5,6.3,8.3,6,14.6-1.2,28.9,0,41.9,7.8,11.1,6.7,24.6,23.4,30.3,35.2v.2c0,1.9-1.9,3.3-3.7,2.6l-5.3-2c-.7-.3-2.6.4-2.9,1-1.2,3.1,3.8,6.7,8.6,9.1,2.2,7.5-8.8,17.5-16.9,20.3l-21,7.5c-7,2.5-26.3,2-32.6-1.4l-9.5-5.1c2.9,11.3,17.8,15.8,28.9,18.8,4.9,1.3,8.5,3.8,11.3,7.5,3.1-.5,6-1.1,8.7-1.8,13.8-3.6,25.8-11.3,37-19.6,13.7-10.2,21.4-24.2,23.5-40,.2-1.2.3-2.5.5-3.7,3.2-10.3,4.6-21.1,5.6-31.8.6-6.7,1.6-13.5.2-20.1Z"
      />
    </g>
    <path
      className="cls-1"
      d="M164.5,152.9c3.8,1.5,3.6,5.6,6.4,7.3,1.8-3.4.9-6-.5-8.9-1.6-3.1-5.3-4.8-8.9-4.1-5.1,1-8.8,7.2-6.6,11.4l4.2-4.4c1.1-1.1,4.1-1.8,5.4-1.2Z"
    />
  </svg>
);
export default SVGComponent;
